<template>
	<div class="box">
		<div class="list_box">
			<div
				v-for="(item, index) in list"
				:key="index"
				@click="selectItem(item)"
			>
				<van-swipe-cell
					:style="{
						width: '100%',
						opacity: item.isEffective == 'Y' ? '1.0' : '0.3',
					}"
				>
					<div class="list_item">
						<div v-if="item.isEffective != 'Y'" class="invaildFlag">
							已失效
						</div>
						<img
							v-if="selectItems.indexOf(item) >= 0"
							class="right_img"
							src="@/assets/order/selected.png"
						/>
						<img
							v-else
							class="right_img"
							src="@/assets/order/unselected.png"
						/>
						<div class="right_box">
							<div class="content_bottom">
								<img
									class="goodsImg"
									:src="getFilePath(item.filePath)"
								/>
								<div class="content_box">
									<div class="title">
										{{ item.productName }}
									</div>
									<div
										class="coupon_list"
										v-if="couponList.length > index"
									>
										<div
											v-for="(coupon, i) in couponList[
												index
											].list"
											:key="'c' + i"
										>
											<div class="coupon_item">
												{{ coupon }}
											</div>
										</div>
									</div>
									<div class="type">
										已选择：{{ item.goodsName }}
									</div>
									<div class="price_num">
										<div class="price">
											¥{{ item.endPrice }}
										</div>
										<div class="nums_box">
											<img
												class="nums_reduce"
												src="@/assets/order/reduce_icon.png"
												@click.stop="reduceNum(item)"
											/>
											<span class="nums_num">{{
												item.orderQuantity
											}}</span>
											<img
												class="nums_reduce"
												src="@/assets/order/add_icon.png"
												@click.stop="addNum(item)"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<template #right>
						<van-button
							square
							text="删除"
							type="danger"
							class="delete-button"
							style="height: 100%"
							@click="deleteItem(item)"
						/>
					</template>
				</van-swipe-cell>
			</div>
			<van-empty description="购物车空空如也" v-if="list.length == 0">
				<van-button
					round
					type="danger"
					class="bottom-button"
					@click="goShop"
					>去选购</van-button
				>
			</van-empty>
			<div class="bottom_box">
				<div class="select_box" @click="toAllSelect">
					<img
						v-if="
							selectItems.length > 0 &&
							selectItems.length == availdList.length
						"
						class="right_img"
						src="@/assets/order/selected.png"
					/>
					<img
						v-else
						class="right_img"
						src="@/assets/order/unselected.png"
					/>
					<div class="select_text">全选</div>
				</div>
				<div
					v-if="isHavaInVaild"
					class="clearAllInvaild"
					@click="clearAllInvaild"
				>
					清空无效商品
				</div>
				<div class="allPrice">
					合计 <span>¥{{ allprice }}</span>
				</div>
				<div class="submit" @click="submit">提交订单</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getImgUrl } from '@/mixins/getImgUrl.js'
import { Dialog, SwipeItem } from 'vant'
export default {
	data() {
		return {
			list: [],
			selectItems: [],
			allprice: '0',
			couponList: [],
			availdList: [],
			isHavaInVaild: false,
		}
	},
	mixins: [getImgUrl],
	methods: {
		//清空无效商品
		clearAllInvaild() {
			this.$API.z_order.clearShopCar().then((res) => {
				this.init()
			})
		},
		// position 为关闭时点击的位置
		// instance 为对应的 SwipeCell 实例
		deleteItem(item) {
			console.log('关闭了')
			console.log(item)
			Dialog.confirm({
				title: '',
				message: '确认从购物车中删除？',
			})
				.then(() => {
					// on confirm
					this.$API.z_product.deleteGoodsCart(item.id).then((res) => {
						if (res.code == 200) {
							let index = this.list.indexOf(item)
							this.list.splice(index, 1)
							let index1 = this.selectItems.indexOf(item)
							if (index1 >= 0) {
								this.selectItems.splice(index1, 1)
							}
						}
					})
				})
				.catch(() => {
					// on cancel
				})
		},
		init() {
			this.$API.z_product.goodsCartList().then((res) => {
				if (res.code == 200) {
					this.list = res.rows
					var tempArr = []
					this.list.forEach((e) => {
						if (e.isEffective == 'Y') {
							tempArr.push(e)
						}
					})
					this.availdList = tempArr
					this.isHavaInVaild =
						this.availdList.length != this.list.length
					this.getCouponData()
				}
			})
		},
		getCouponData() {
			var params = {
				productType: '4',
				productIds: [],
				userId: this.$store.getters.userInfo_v2.user.userId,
				tenantId: this.$store.getters.userInfo_v2.user.tenantId,
				receiveChannel: 'h5',
			}
			for (let index = 0; index < this.list.length; index++) {
				const e = this.list[index]
				if (params.productIds.indexOf(e.productId) == -1) {
					params.productIds.push(e.productId)
				}
			}
			this.$API.coupons.selectCouponsList(params).then((res) => {
				const couponData = res.data
				for (let index = 0; index < this.list.length; index++) {
					var e = this.list[index]
					for (let i = 0; i < couponData.length; i++) {
						const item = couponData[i]
						if (item.productId == e.productId) {
							var temparr = []
							for (let j = 0; j < item.couponsList.length; j++) {
								const element = item.couponsList[j]
								if (j < 2) {
									temparr.push(element.name)
								} else {
									continue
								}
							}
							this.couponList.push({ list: temparr })
							continue
						}
					}
				}
				console.log(this.list)
			})
		},
		selectItem(item) {
			if (item.isEffective == 'N') {
				return
			}
			let index = this.selectItems.indexOf(item)
			console.log(index)
			if (index >= 0) {
				this.selectItems.splice(index, 1)
			} else {
				this.selectItems.push(item)
			}
			this.calculatePrice()
		},
		toAllSelect() {
			var arr = this.list
			if (this.selectItems.length === this.availdList.length) {
				this.selectItems = []
			} else {
				this.selectItems = []

				this.selectItems = this.selectItems.concat(this.availdList)
			}

			this.calculatePrice()
		},
		calculatePrice() {
			var tempPrice = 0
			for (let index = 0; index < this.selectItems.length; index++) {
				const e = this.selectItems[index]
				tempPrice = tempPrice + e.endPrice * e.orderQuantity
			}
			this.allprice = tempPrice.toFixed(2)
		},
		submit() {
			if (this.selectItems.length == 0) {
				this.$toast('请选择需购买的商品')
				return false
			}
			var tempArr = []
			var productIds = []

			for (let index = 0; index < this.selectItems.length; index++) {
				const e = this.selectItems[index]
				let filePath = e.filePath
				let goods = {
					fastFareType: e.fastFareType,
					fixedFreight: e.fastFareType,
					id: e.productId,
					isSelfProvided: e.isSelfProvided,
					productName: e.productName,
					selfProvidedAddress: e.selfProvidedAddress,
					tempId: e.tempId,
				}
				let orderGoodsDetailList = {
					distributionPrice: e.endPrice,
					marketPrice: e.endPrice,
					goodsId: e.goodsId,
					orderQuantity: e.orderQuantity,
					specName: e.goodsName,
					cartId: e.id,
				}

				const lastIndex = productIds.indexOf(e.productId)
				if (lastIndex === -1){
					tempArr.push({
						filePath: filePath,
						goods: goods,
						orderGoodsDetailList: [orderGoodsDetailList],
					})
					productIds.push(e.productId)
				}else{
					const item = tempArr[lastIndex]
					item.orderGoodsDetailList.push(orderGoodsDetailList)
				}
			}

			console.log(tempArr)
			this.$router.push({
				path: '/order/goods_place_order',
				query: {
					goodsDetails: JSON.stringify(tempArr),
				},
			})
		},
		goShop() {
			this.$router.go(-1)
		},
		reduceNum(item) {
			if (item.orderQuantity < 2) {
				return
			}
			const data = {
				id: item.id,
				goodsId: item.goodsId,
				goodsName: item.goodsName,
				orderQuantity: item.orderQuantity - 1,
			}
			this.$API.z_order.goodsCart(data).then((res) => {
				item.orderQuantity = item.orderQuantity - 1
				this.calculatePrice()
			})
		},
		addNum(item) {
			const data = {
				id: item.id,
				goodsId: item.goodsId,
				goodsName: item.goodsName,
				orderQuantity: item.orderQuantity + 1,
			}
			this.$API.z_order.goodsCart(data).then((res) => {
				item.orderQuantity = item.orderQuantity + 1
				this.calculatePrice()
			})
		},
	},
	mounted() {
		this.init()
	},
}
</script>

<style lang="scss" scoped>
.box {
	background-color: #f4f6f9;
	height: 100%;
	.list_box {
		display: flex;
		flex-direction: column;
		padding-bottom: vw(160);
		.list_item {
			position: relative;
			margin-left: vw(32);
			margin-right: vw(32);
			margin-top: vw(24);
			padding-top: vw(30);
			padding-bottom: vw(30);
			background-color: #ffffff;
			border-radius: vw(12);
			display: flex;
			flex-direction: row;
			align-items: center;
			.invaildFlag {
				position: absolute;
				right: vw(5);
				top: vw(5);
				border: 1px #ff3530 solid;
				border-radius: vw(4);
				padding: vw(2) vw(8);
				color: #ff3530;
				font-size: vw(20);
			}
			.right_img {
				width: vw(34);
				height: vw(34);
				margin-left: vw(21);
				margin-right: vw(21);
			}
			.right_box {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				.coupon_str {
					color: #ff3333;
					font-size: vw(20);
					margin-bottom: vw(10);
				}
				.content_bottom {
					display: flex;
					flex-direction: row;

					.goodsImg {
						width: vw(160);
						height: vw(160);
						border-radius: vw(8);
						background-color: red;
					}
					.content_box {
						margin-left: vw(21);
						margin-right: vw(20);
						// height: vw(160);
						flex: 1;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						.title {
							width: vw(400);
							font-size: vw(28);
							font-weight: bold;
							color: #333333;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.coupon_list {
							display: flex;
							flex-direction: row;
							align-items: center;
							.coupon_item {
								margin-right: vw(8);
								margin-top: vw(4);
								border: vw(0.5) #c6a753 solid;
								color: #c6a753;
								font-size: vw(18);
								padding: vw(1) vw(5);
								border-radius: vw(3);
							}
						}
						.type {
							width: vw(410);
							color: #666666;
							font-size: vw(28);
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-top: vw(4);
						}
						.price_num {
							margin-top: vw(4);
							display: flex;
							flex-direction: row;
							align-items: center;
							justify-content: space-between;
							.price {
								font-size: vw(36);
								color: #ff3333;
							}

							.nums_box {
								display: flex;
								flex-direction: row;
								align-items: center;
								.nums_reduce {
									margin-left: vw(20);
									width: vw(35);
									height: vw(35);
								}
								.nums_num {
									margin-left: vw(20);
									font-size: vw(26);
									color: #333333;
								}
							}
						}
					}
				}
			}
		}
	}
	.bottom_box {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		height: vw(110);
		background-color: #ffffff;
		padding-bottom: vw(30);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		.select_box {
			display: flex;
			flex-direction: row;
			align-items: center;
			.right_img {
				margin-left: vw(32);
				margin-right: vw(15);
				width: vw(34);
				height: vw(34);
			}
			.select_text {
				font-size: vw(30);
				color: #333333;
			}
		}
		.clearAllInvaild {
			font-size: vw(25);
			color: #666666;
		}
		.allPrice {
			font-size: vw(25);
			color: #333333;
			span {
				color: #ff3333;
				font-size: vw(30);
			}
		}
		.submit {
			background: linear-gradient(to right, #ff8433, #ff3530);
			font-size: vw(30);
			color: #ffffff;
			padding: vw(15) vw(30);
			border-radius: vw(8);
			margin-right: vw(32);
		}
	}
	.bottom-button {
		width: 160px;
		height: 40px;
	}
}
</style>
